// Phantom Residence — Multilingual content (TR, EN, AR, RU)
// Turkish is the source of truth. RTL applies to Arabic.

export const LANGUAGES = [
  { code: "tr", label: "Türkçe", short: "TR", dir: "ltr" },
  { code: "en", label: "English", short: "EN", dir: "ltr" },
  { code: "ar", label: "العربية", short: "AR", dir: "rtl" },
  { code: "ru", label: "Русский", short: "RU", dir: "ltr" },
];

export const translations = {
  tr: {
    nav: {
      home: "Ana Sayfa",
      about: "Proje",
      features: "Özellikler",
      masterplan: "Vaziyet Planı",
      residence: "Rezidans + Otel",
      location: "Lokasyon",
      plans: "Planlar",
      gallery: "Galeri",
      contact: "İletişim",
      cta: "Randevu Al",
    },
    hero: {
      overline: "PHANTOM RESIDENCE",
      title: "Sessiz Lüksün Yeni Adresi",
      subtitle:
        "Rezidans, ticari alanlar, otel, termal ve sağlık tesisi konseptiyle modern şehir yaşamının yeni merkezi.",
      promise: "İstanbul'un ilk termal otel konsepti, Phantom Residence ayrıcalığıyla yükseliyor.",
      cta1: "Projeyi İncele",
      cta2: "Randevu Al",
      cta3: "WhatsApp ile Bilgi Al",
    },
    about: {
      overline: "Proje Hakkında",
      title: "Phantom Residence Hakkında",
      text: "Phantom Residence, modern şehir yaşamını rezidans konforu, ticari alanlar, otel konsepti, termal tesis ve sağlık odaklı yaşam alanlarıyla bir araya getiren prestijli bir karma yaşam projesidir. Mimari formu, güçlü lokasyonu ve çok fonksiyonlu yapısıyla hem yaşam hem yatırım açısından yüksek potansiyel sunar.",
      cards: [
        { title: "Rezidans Yaşamı", text: "Yüksek katlı mimaride, şehre hâkim, konforlu ve özel rezidans yaşamı." },
        { title: "Ticari Alanlar", text: "AVM, dükkân ve market alanlarıyla canlı ve sürdürülebilir ticari hareketlilik." },
        { title: "Termal & Sağlık Tesisi", text: "Termal tesis ve sağlık odaklı alanlarla iyi yaşam ve sağlık turizmi konsepti." },
        { title: "Yatırım Değeri", text: "Karma kullanım yapısı ve merkezi lokasyonla güçlü yatırım potansiyeli." },
      ],
    },
    features: {
      overline: "Proje Özellikleri",
      title: "Teknik Genel Bakış",
      general: [
        { label: "Arsa Alanı", value: "18.146", unit: "m²" },
        { label: "Toplam İnşaat Alanı", value: "170.000", unit: "m²" },
        { label: "Toplam Bağımsız Birim", value: "1.162", unit: "" },
        { label: "Toplam Konut Adedi", value: "1.109", unit: "" },
        { label: "Toplam Ticari Ünite", value: "53", unit: "" },
      ],
      blockTitle: "C Blok / Rezidans Detayları",
      block: [
        { label: "C Blok İnşaat Alanı", value: "47.436,97 m²" },
        { label: "Konut Alanı", value: "21.270,07 m²" },
        { label: "Dükkan Alanı", value: "5.551 m²" },
        { label: "Market Alanı", value: "1.084,55 m²" },
        { label: "AVM Alanı", value: "7.893,40 m²" },
        { label: "Çok Amaçlı Salon", value: "2.141,40 m²" },
        { label: "Kat Adedi", value: "39" },
        { label: "Konut Adedi", value: "266" },
        { label: "Dükkan Adedi", value: "26" },
        { label: "Otopark Kapasitesi", value: "415" },
        { label: "Termal Tesis Alanı", value: "3.092 m²" },
      ],
    },
    masterplan: {
      overline: "Vaziyet Planı",
      title: "Vaziyet Planı",
      text: "Projenin genel yerleşimini; blokları, sosyal alanları, girişleri ve ticari alanları detaylı şekilde inceleyin.",
      tabs: [
        "Genel Vaziyet Planı",
        "C Blok Rezidans Alanı",
        "Girişler & Otopark",
        "Sosyal Alanlar",
        "Ticari Alanlar",
      ],
      zoomHint: "Büyütmek için tıklayın",
      legend: [
        "A Blok Konut", "B Blok Konut", "C Blok Rezidans / Otel", "D Blok Konut",
        "Tıp Merkezi", "Cami", "Sosyal Alanlar", "Spor Alanı",
        "Havuz / Peyzaj", "Otopark Girişleri", "Site Girişleri", "AVM / Otel / Rezidans Girişleri",
      ],
    },
    residence: {
      overline: "Rezidans + Otel",
      title: "Ramada İş Birliğiyle İstanbul'un İlk Termal Otel Konsepti",
      text: "Phantom Residence, İstanbul'da termal otel konseptini rezidans, ticari alanlar ve sağlık tesisi yapısıyla bir araya getiren prestijli bir karma yaşam projesidir. Ramada iş birliğiyle planlanan otel alanı, projeye yalnızca konaklama değeri değil; yatırım, sağlık turizmi ve prestij açısından da güçlü bir ayrıcalık kazandırır.",
      text2: "Yüksek katlı mimarisiyle rezidans konforunu otel konseptiyle birleştirir. Şehir manzarasına hâkim yapısı, modern cephe tasarımı ve çok amaçlı kullanım alanlarıyla seçkin bir yaşam ve konaklama deneyimi sunar.",
      ramadaNote: "Ramada İş Birliği",
      floors: [
        { name: "Rezidans", desc: "Konforlu ve özel yaşam katları" },
        { name: "Otel", desc: "Ramada iş birliğiyle konaklama" },
        { name: "Ticari Alanlar", desc: "AVM, dükkân ve market" },
        { name: "Termal & Sağlık Alanları", desc: "Termal tesis ve sağlık konsepti" },
      ],
    },
    location: {
      overline: "Lokasyon",
      title: "Stratejik Lokasyon",
      text: "Esenyurt bölgesinde merkezi konumuyla, şehrin yaşam ve ulaşım akslarına güçlü bağlantı sunar.",
      advantages: [
        "Esenyurt bölgesinde merkezi konum",
        "Proje etrafında AVM, hastane ve sosyal yaşam alanları",
        "Tüyap Kongre ve Fuar Alanı'na yaklaşık 5 km",
        "Ulaşım bağlantılarına yakın",
        "Marmara Park, Torium AVM, City Center AVM, Perlavista AVM gibi noktalara erişim",
        "İstanbul Havalimanı ve bölgesel ulaşım akslarına bağlantı",
      ],
    },
    plans: {
      overline: "Proje Planları",
      title: "Planlar",
      text: "Tüm proje plan ve dokümanlarını kategori bazlı, düzenli bir galeride inceleyin.",
      categories: [
        "Tümü",
        "Genel Tanıtım",
        "Lokasyon Haritaları",
        "Vaziyet Planı",
        "Rezidans + Otel",
        "C Blok Teknik Bilgiler",
        "Kat Planları",
        "Daire Tipleri",
        "Ticari Alanlar",
        "Otel / Ramada Alanı",
        "Termal & Sağlık Tesisi",
      ],
      fullscreen: "Tam Ekran",
      download: "İndir",
      sourceNote: "Teknik kaynak görseli",
    },
    gallery: {
      overline: "Galeri",
      title: "Görsel Galeri",
      text: "Phantom Residence'ın mimari estetiğini ve yaşam alanlarını keşfedin.",
      filters: [
        "Tümü", "Dış Cephe", "Kule", "Girişler", "Peyzaj", "Gece Görünümü", "Ticari Alanlar",
      ],
    },
    investment: {
      overline: "Yatırım",
      title: "Yaşam ve Yatırım Değeri",
      text: "Phantom Residence, karma kullanım yapısı, rezidans konforu, ticari alanları, sağlık ve termal tesis konseptiyle sadece bugünün yaşam ihtiyacına değil, geleceğin yatırım potansiyeline de hitap eder.",
      cards: [
        { title: "Karma Proje Avantajı", text: "Rezidans, ticari, otel ve sağlık fonksiyonlarının tek projede buluşması." },
        { title: "Ticari Hareketlilik", text: "AVM ve ticari ünitelerle sürekli canlı bir yaşam ekosistemi." },
        { title: "Merkezi Lokasyon", text: "Esenyurt'ta ulaşım ve yaşam akslarına yakın stratejik konum." },
        { title: "Yüksek Bağımsız Birim Sayısı", text: "1.162 bağımsız birimle güçlü bir yaşam ve yatırım ölçeği." },
        { title: "Rezidans + Otel Kullanımı", text: "Ramada iş birliğiyle konaklama ve kira getirisi potansiyeli." },
        { title: "Sağlık & Termal Konsept", text: "İstanbul'un ilk termal otel konseptiyle sağlık turizmi değeri." },
      ],
    },
    contact: {
      overline: "İletişim",
      title: "Randevu & İletişim",
      text: "Proje hakkında detaylı bilgi almak veya randevu oluşturmak için bizimle iletişime geçin.",
      name: "Ad Soyad",
      phone: "Telefon",
      email: "E-posta",
      interest: "İlgilendiğiniz Alan",
      interestOptions: ["Rezidans", "Ticari Alan", "Yatırım", "Otel / Termal / Sağlık Tesisi"],
      message: "Mesaj",
      submit: "Randevu Talep Et",
      whatsapp: "WhatsApp ile Hemen Görüş",
      call: "Telefonla Ara",
      success: "Talebiniz alındı. En kısa sürede sizinle iletişime geçeceğiz.",
      error: "Bir hata oluştu. Lütfen tekrar deneyin.",
      sending: "Gönderiliyor...",
      required: "Lütfen zorunlu alanları doldurun.",
    },
    footer: {
      tagline: "Sessiz lüksün yeni adresi",
      rights: "Tüm hakları saklıdır.",
      menu: "Menü",
      contact: "İletişim",
      disclaimer: "Bu web sitesindeki görseller ve bilgiler tanıtım amaçlıdır. Teknik dokümanlar kaynak niteliğindedir.",
    },
  },

  en: {
    nav: {
      home: "Home", about: "Project", features: "Features", masterplan: "Site Plan",
      residence: "Residence + Hotel", location: "Location", plans: "Plans", gallery: "Gallery",
      contact: "Contact", cta: "Book a Visit",
    },
    hero: {
      overline: "PHANTOM RESIDENCE",
      title: "The New Address of Quiet Luxury",
      subtitle: "A new center of modern urban living with residence, commercial spaces, hotel, thermal and health facility concept.",
      promise: "Istanbul's first thermal hotel concept rises with the Phantom Residence privilege.",
      cta1: "Explore the Project", cta2: "Book a Visit", cta3: "Get Info via WhatsApp",
    },
    about: {
      overline: "About the Project",
      title: "About Phantom Residence",
      text: "Phantom Residence is a prestigious mixed-use living project that brings together modern urban life with residence comfort, commercial spaces, a hotel concept, a thermal facility and health-focused living areas. With its architectural form, strong location and multifunctional structure, it offers high potential for both living and investment.",
      cards: [
        { title: "Residence Living", text: "Comfortable, private high-rise residence living overlooking the city." },
        { title: "Commercial Spaces", text: "Vibrant, sustainable commercial energy with mall, shops and market areas." },
        { title: "Thermal & Health Facility", text: "Wellness and health tourism concept with thermal and health-focused areas." },
        { title: "Investment Value", text: "Strong investment potential with mixed-use structure and central location." },
      ],
    },
    features: {
      overline: "Project Features",
      title: "Technical Overview",
      general: [
        { label: "Land Area", value: "18.146", unit: "m²" },
        { label: "Total Construction Area", value: "170.000", unit: "m²" },
        { label: "Total Independent Units", value: "1.162", unit: "" },
        { label: "Total Residences", value: "1.109", unit: "" },
        { label: "Total Commercial Units", value: "53", unit: "" },
      ],
      blockTitle: "Block C / Residence Details",
      block: [
        { label: "Block C Construction Area", value: "47,436.97 m²" },
        { label: "Residence Area", value: "21,270.07 m²" },
        { label: "Shop Area", value: "5,551 m²" },
        { label: "Market Area", value: "1,084.55 m²" },
        { label: "Mall Area", value: "7,893.40 m²" },
        { label: "Multipurpose Hall", value: "2,141.40 m²" },
        { label: "Number of Floors", value: "39" },
        { label: "Number of Residences", value: "266" },
        { label: "Number of Shops", value: "26" },
        { label: "Parking Capacity", value: "415" },
        { label: "Thermal Facility Area", value: "3,092 m²" },
      ],
    },
    masterplan: {
      overline: "Site Plan", title: "Site Plan",
      text: "Explore the overall layout of the project; blocks, social areas, entrances and commercial spaces in detail.",
      tabs: ["General Site Plan", "Block C Residence Area", "Entrances & Parking", "Social Areas", "Commercial Areas"],
      zoomHint: "Click to enlarge",
      legend: ["Block A Residential", "Block B Residential", "Block C Residence / Hotel", "Block D Residential",
        "Medical Center", "Mosque", "Social Areas", "Sports Area", "Pool / Landscape",
        "Parking Entrances", "Site Entrances", "Mall / Hotel / Residence Entrances"],
    },
    residence: {
      overline: "Residence + Hotel",
      title: "Istanbul's First Thermal Hotel Concept in Collaboration with Ramada",
      text: "Phantom Residence is a prestigious mixed-use project that brings the thermal hotel concept together with residence, commercial spaces and a health facility in Istanbul. The hotel area, planned in collaboration with Ramada, adds not only accommodation value but also a strong privilege in terms of investment, health tourism and prestige.",
      text2: "It combines residence comfort with a hotel concept through its high-rise architecture. With its structure overlooking the city, modern façade and multipurpose areas, it offers a distinguished living and accommodation experience.",
      ramadaNote: "Ramada Collaboration",
      floors: [
        { name: "Residence", desc: "Comfortable and private living floors" },
        { name: "Hotel", desc: "Accommodation in collaboration with Ramada" },
        { name: "Commercial Areas", desc: "Mall, shops and market" },
        { name: "Thermal & Health Areas", desc: "Thermal facility and health concept" },
      ],
    },
    location: {
      overline: "Location", title: "Strategic Location",
      text: "With its central position in the Esenyurt area, it offers strong connections to the city's living and transport axes.",
      advantages: [
        "Central location in the Esenyurt area",
        "Malls, hospitals and social living areas around the project",
        "Approximately 5 km to Tüyap Congress and Fair Center",
        "Close to transportation connections",
        "Access to points such as Marmara Park, Torium Mall, City Center Mall, Perlavista Mall",
        "Connection to Istanbul Airport and regional transport axes",
      ],
    },
    plans: {
      overline: "Project Plans", title: "Plans",
      text: "Browse all project plans and documents in an organized, category-based gallery.",
      categories: ["All", "General Introduction", "Location Maps", "Site Plan", "Residence + Hotel",
        "Block C Technical Info", "Floor Plans", "Apartment Types", "Commercial Areas", "Hotel / Ramada Area", "Thermal & Health Facility"],
      fullscreen: "Fullscreen", download: "Download", sourceNote: "Technical source visual",
    },
    gallery: {
      overline: "Gallery", title: "Visual Gallery",
      text: "Discover the architectural aesthetics and living spaces of Phantom Residence.",
      filters: ["All", "Exterior", "Tower", "Entrances", "Landscape", "Night View", "Commercial Areas"],
    },
    investment: {
      overline: "Investment", title: "Living and Investment Value",
      text: "With its mixed-use structure, residence comfort, commercial spaces, health and thermal facility concept, Phantom Residence appeals not only to today's living needs but also to the investment potential of the future.",
      cards: [
        { title: "Mixed-Use Advantage", text: "Residence, commercial, hotel and health functions meet in a single project." },
        { title: "Commercial Vitality", text: "A constantly vibrant living ecosystem with mall and commercial units." },
        { title: "Central Location", text: "Strategic position in Esenyurt close to transport and living axes." },
        { title: "High Number of Units", text: "A strong living and investment scale with 1,162 independent units." },
        { title: "Residence + Hotel Use", text: "Accommodation and rental return potential in collaboration with Ramada." },
        { title: "Health & Thermal Concept", text: "Health tourism value with Istanbul's first thermal hotel concept." },
      ],
    },
    contact: {
      overline: "Contact", title: "Appointment & Contact",
      text: "Contact us to get detailed information about the project or to make an appointment.",
      name: "Full Name", phone: "Phone", email: "Email", interest: "Area of Interest",
      interestOptions: ["Residence", "Commercial Space", "Investment", "Hotel / Thermal / Health Facility"],
      message: "Message", submit: "Request Appointment", whatsapp: "Chat on WhatsApp Now", call: "Call Now",
      success: "Your request has been received. We will contact you shortly.",
      error: "An error occurred. Please try again.", sending: "Sending...",
      required: "Please fill in the required fields.",
    },
    footer: {
      tagline: "The new address of quiet luxury", rights: "All rights reserved.",
      menu: "Menu", contact: "Contact",
      disclaimer: "The visuals and information on this website are for promotional purposes. Technical documents are reference materials.",
    },
  },

  ar: {
    nav: {
      home: "الرئيسية", about: "المشروع", features: "المميزات", masterplan: "المخطط العام",
      residence: "السكن + الفندق", location: "الموقع", plans: "المخططات", gallery: "المعرض",
      contact: "تواصل", cta: "احجز موعداً",
    },
    hero: {
      overline: "فانتوم ريزيدنس",
      title: "العنوان الجديد للفخامة الهادئة",
      subtitle: "مركز جديد للحياة الحضرية العصرية بمفهوم السكن والمساحات التجارية والفندق والمنشآت الحرارية والصحية.",
      promise: "أول مفهوم فندق حراري في إسطنبول يرتقي بامتياز فانتوم ريزيدنس.",
      cta1: "استكشف المشروع", cta2: "احجز موعداً", cta3: "احصل على المعلومات عبر واتساب",
    },
    about: {
      overline: "عن المشروع", title: "عن فانتوم ريزيدنس",
      text: "فانتوم ريزيدنس هو مشروع سكني متعدد الاستخدامات مرموق يجمع بين الحياة الحضرية العصرية وراحة السكن والمساحات التجارية ومفهوم الفندق والمنشأة الحرارية والمساحات المعيشية الصحية. بفضل شكله المعماري وموقعه القوي وبنيته متعددة الوظائف، يوفر إمكانات عالية للسكن والاستثمار.",
      cards: [
        { title: "الحياة السكنية", text: "حياة سكنية مريحة وخاصة في برج شاهق يطل على المدينة." },
        { title: "المساحات التجارية", text: "حيوية تجارية مستدامة مع مركز تجاري ومحلات وأسواق." },
        { title: "المنشأة الحرارية والصحية", text: "مفهوم العافية والسياحة الصحية مع مساحات حرارية وصحية." },
        { title: "القيمة الاستثمارية", text: "إمكانات استثمارية قوية ببنية متعددة الاستخدامات وموقع مركزي." },
      ],
    },
    features: {
      overline: "مميزات المشروع", title: "نظرة تقنية عامة",
      general: [
        { label: "مساحة الأرض", value: "18.146", unit: "م²" },
        { label: "إجمالي مساحة البناء", value: "170.000", unit: "م²" },
        { label: "إجمالي الوحدات المستقلة", value: "1.162", unit: "" },
        { label: "إجمالي الوحدات السكنية", value: "1.109", unit: "" },
        { label: "إجمالي الوحدات التجارية", value: "53", unit: "" },
      ],
      blockTitle: "تفاصيل البلوك C / السكن",
      block: [
        { label: "مساحة بناء البلوك C", value: "47.436,97 م²" },
        { label: "المساحة السكنية", value: "21.270,07 م²" },
        { label: "مساحة المحلات", value: "5.551 م²" },
        { label: "مساحة السوق", value: "1.084,55 م²" },
        { label: "مساحة المركز التجاري", value: "7.893,40 م²" },
        { label: "قاعة متعددة الأغراض", value: "2.141,40 م²" },
        { label: "عدد الطوابق", value: "39" },
        { label: "عدد الوحدات السكنية", value: "266" },
        { label: "عدد المحلات", value: "26" },
        { label: "سعة المواقف", value: "415" },
        { label: "مساحة المنشأة الحرارية", value: "3.092 م²" },
      ],
    },
    masterplan: {
      overline: "المخطط العام", title: "المخطط العام",
      text: "استكشف التخطيط العام للمشروع؛ البلوكات والمناطق الاجتماعية والمداخل والمساحات التجارية بالتفصيل.",
      tabs: ["المخطط العام", "منطقة سكن البلوك C", "المداخل والمواقف", "المناطق الاجتماعية", "المناطق التجارية"],
      zoomHint: "انقر للتكبير",
      legend: ["البلوك A سكني", "البلوك B سكني", "البلوك C سكن / فندق", "البلوك D سكني",
        "مركز طبي", "مسجد", "مناطق اجتماعية", "منطقة رياضية", "مسبح / مناظر طبيعية",
        "مداخل المواقف", "مداخل الموقع", "مداخل المركز / الفندق / السكن"],
    },
    residence: {
      overline: "السكن + الفندق",
      title: "أول مفهوم فندق حراري في إسطنبول بالتعاون مع رمادا",
      text: "فانتوم ريزيدنس مشروع متعدد الاستخدامات مرموق يجمع مفهوم الفندق الحراري مع السكن والمساحات التجارية والمنشأة الصحية في إسطنبول. تضيف منطقة الفندق المخططة بالتعاون مع رمادا قيمة إقامة بالإضافة إلى امتياز قوي من حيث الاستثمار والسياحة الصحية والمكانة.",
      text2: "يجمع بين راحة السكن ومفهوم الفندق من خلال هندسته الشاهقة. ببنيته المطلة على المدينة وواجهته العصرية ومساحاته متعددة الأغراض، يقدم تجربة معيشة وإقامة مميزة.",
      ramadaNote: "بالتعاون مع رمادا",
      floors: [
        { name: "السكن", desc: "طوابق معيشة مريحة وخاصة" },
        { name: "الفندق", desc: "إقامة بالتعاون مع رمادا" },
        { name: "المساحات التجارية", desc: "مركز تجاري ومحلات وسوق" },
        { name: "المناطق الحرارية والصحية", desc: "منشأة حرارية ومفهوم صحي" },
      ],
    },
    location: {
      overline: "الموقع", title: "موقع استراتيجي",
      text: "بموقعه المركزي في منطقة إسنيورت، يوفر اتصالات قوية بمحاور الحياة والنقل في المدينة.",
      advantages: [
        "موقع مركزي في منطقة إسنيورت",
        "مراكز تجارية ومستشفيات ومناطق معيشة اجتماعية حول المشروع",
        "حوالي 5 كم إلى مركز توياب للمؤتمرات والمعارض",
        "قريب من وصلات النقل",
        "الوصول إلى نقاط مثل مرمرة بارك، توريوم مول، سيتي سنتر مول، بيرلافيستا مول",
        "اتصال بمطار إسطنبول ومحاور النقل الإقليمية",
      ],
    },
    plans: {
      overline: "مخططات المشروع", title: "المخططات",
      text: "تصفح جميع مخططات ووثائق المشروع في معرض منظم قائم على الفئات.",
      categories: ["الكل", "تعريف عام", "خرائط الموقع", "المخطط العام", "السكن + الفندق",
        "معلومات تقنية للبلوك C", "مخططات الطوابق", "أنواع الشقق", "المساحات التجارية", "منطقة الفندق / رمادا", "المنشأة الحرارية والصحية"],
      fullscreen: "ملء الشاشة", download: "تنزيل", sourceNote: "صورة مصدر تقني",
    },
    gallery: {
      overline: "المعرض", title: "معرض الصور",
      text: "اكتشف الجماليات المعمارية ومساحات المعيشة في فانتوم ريزيدنس.",
      filters: ["الكل", "الواجهة الخارجية", "البرج", "المداخل", "المناظر الطبيعية", "منظر ليلي", "المساحات التجارية"],
    },
    investment: {
      overline: "الاستثمار", title: "قيمة المعيشة والاستثمار",
      text: "ببنيته متعددة الاستخدامات وراحة السكن والمساحات التجارية ومفهوم المنشأة الصحية والحرارية، يلبي فانتوم ريزيدنس احتياجات المعيشة اليوم بالإضافة إلى إمكانات الاستثمار المستقبلية.",
      cards: [
        { title: "ميزة المشروع المختلط", text: "تلتقي وظائف السكن والتجارة والفندق والصحة في مشروع واحد." },
        { title: "الحيوية التجارية", text: "نظام معيشي حيوي دائم مع مركز تجاري ووحدات تجارية." },
        { title: "موقع مركزي", text: "موقع استراتيجي في إسنيورت قريب من محاور النقل والمعيشة." },
        { title: "عدد كبير من الوحدات", text: "مقياس قوي للمعيشة والاستثمار مع 1.162 وحدة مستقلة." },
        { title: "استخدام السكن + الفندق", text: "إمكانات الإقامة وعائد الإيجار بالتعاون مع رمادا." },
        { title: "مفهوم صحي وحراري", text: "قيمة السياحة الصحية مع أول مفهوم فندق حراري في إسطنبول." },
      ],
    },
    contact: {
      overline: "تواصل", title: "موعد وتواصل",
      text: "تواصل معنا للحصول على معلومات مفصلة عن المشروع أو لتحديد موعد.",
      name: "الاسم الكامل", phone: "الهاتف", email: "البريد الإلكتروني", interest: "مجال الاهتمام",
      interestOptions: ["السكن", "مساحة تجارية", "استثمار", "فندق / حراري / منشأة صحية"],
      message: "الرسالة", submit: "اطلب موعداً", whatsapp: "تحدث عبر واتساب الآن", call: "اتصل الآن",
      success: "تم استلام طلبك. سنتواصل معك قريباً.",
      error: "حدث خطأ. يرجى المحاولة مرة أخرى.", sending: "جاري الإرسال...",
      required: "يرجى ملء الحقول المطلوبة.",
    },
    footer: {
      tagline: "العنوان الجديد للفخامة الهادئة", rights: "جميع الحقوق محفوظة.",
      menu: "القائمة", contact: "تواصل",
      disclaimer: "الصور والمعلومات على هذا الموقع لأغراض ترويجية. الوثائق التقنية هي مواد مرجعية.",
    },
  },

  ru: {
    nav: {
      home: "Главная", about: "Проект", features: "Характеристики", masterplan: "Генплан",
      residence: "Резиденция + Отель", location: "Локация", plans: "Планы", gallery: "Галерея",
      contact: "Контакты", cta: "Записаться",
    },
    hero: {
      overline: "PHANTOM RESIDENCE",
      title: "Новый адрес тихой роскоши",
      subtitle: "Новый центр современной городской жизни с концепцией резиденции, коммерческих площадей, отеля, термального и оздоровительного комплекса.",
      promise: "Первая в Стамбуле концепция термального отеля поднимается с привилегией Phantom Residence.",
      cta1: "Изучить проект", cta2: "Записаться", cta3: "Узнать в WhatsApp",
    },
    about: {
      overline: "О проекте", title: "О Phantom Residence",
      text: "Phantom Residence — это престижный многофункциональный жилой проект, объединяющий современную городскую жизнь с комфортом резиденции, коммерческими площадями, концепцией отеля, термальным комплексом и оздоровительными зонами. Благодаря архитектурной форме, сильному расположению и многофункциональной структуре он обладает высоким потенциалом как для жизни, так и для инвестиций.",
      cards: [
        { title: "Жизнь в резиденции", text: "Комфортная приватная жизнь в высотной резиденции с видом на город." },
        { title: "Коммерческие площади", text: "Динамичная коммерческая среда с ТЦ, магазинами и маркетами." },
        { title: "Термальный и оздоровительный комплекс", text: "Концепция велнеса и оздоровительного туризма с термальными зонами." },
        { title: "Инвестиционная ценность", text: "Сильный инвестиционный потенциал благодаря многофункциональности и центральному расположению." },
      ],
    },
    features: {
      overline: "Характеристики проекта", title: "Технический обзор",
      general: [
        { label: "Площадь участка", value: "18.146", unit: "м²" },
        { label: "Общая площадь застройки", value: "170.000", unit: "м²" },
        { label: "Всего независимых единиц", value: "1.162", unit: "" },
        { label: "Всего резиденций", value: "1.109", unit: "" },
        { label: "Всего коммерческих единиц", value: "53", unit: "" },
      ],
      blockTitle: "Блок C / Детали резиденции",
      block: [
        { label: "Площадь застройки блока C", value: "47.436,97 м²" },
        { label: "Жилая площадь", value: "21.270,07 м²" },
        { label: "Площадь магазинов", value: "5.551 м²" },
        { label: "Площадь маркета", value: "1.084,55 м²" },
        { label: "Площадь ТЦ", value: "7.893,40 м²" },
        { label: "Многофункциональный зал", value: "2.141,40 м²" },
        { label: "Количество этажей", value: "39" },
        { label: "Количество резиденций", value: "266" },
        { label: "Количество магазинов", value: "26" },
        { label: "Вместимость парковки", value: "415" },
        { label: "Площадь термального комплекса", value: "3.092 м²" },
      ],
    },
    masterplan: {
      overline: "Генплан", title: "Генеральный план",
      text: "Изучите общую планировку проекта: блоки, социальные зоны, входы и коммерческие площади в деталях.",
      tabs: ["Общий генплан", "Зона резиденции блок C", "Входы и парковка", "Социальные зоны", "Коммерческие зоны"],
      zoomHint: "Нажмите для увеличения",
      legend: ["Блок A жилой", "Блок B жилой", "Блок C резиденция / отель", "Блок D жилой",
        "Медицинский центр", "Мечеть", "Социальные зоны", "Спортивная зона", "Бассейн / ландшафт",
        "Въезды на парковку", "Входы на территорию", "Входы ТЦ / отель / резиденция"],
    },
    residence: {
      overline: "Резиденция + Отель",
      title: "Первая в Стамбуле концепция термального отеля в сотрудничестве с Ramada",
      text: "Phantom Residence — престижный многофункциональный проект, объединяющий концепцию термального отеля с резиденцией, коммерческими площадями и оздоровительным комплексом в Стамбуле. Зона отеля, спланированная в сотрудничестве с Ramada, добавляет не только ценность размещения, но и сильную привилегию с точки зрения инвестиций, оздоровительного туризма и престижа.",
      text2: "Высотная архитектура объединяет комфорт резиденции с концепцией отеля. Со структурой с видом на город, современным фасадом и многофункциональными зонами он предлагает изысканный опыт проживания и размещения.",
      ramadaNote: "Сотрудничество с Ramada",
      floors: [
        { name: "Резиденция", desc: "Комфортные приватные жилые этажи" },
        { name: "Отель", desc: "Размещение в сотрудничестве с Ramada" },
        { name: "Коммерческие зоны", desc: "ТЦ, магазины и маркет" },
        { name: "Термальные и оздоровительные зоны", desc: "Термальный комплекс и оздоровительная концепция" },
      ],
    },
    location: {
      overline: "Локация", title: "Стратегическая локация",
      text: "Благодаря центральному расположению в районе Эсенюрт, проект предлагает прочные связи с жизненными и транспортными осями города.",
      advantages: [
        "Центральное расположение в районе Эсенюрт",
        "Торговые центры, больницы и социальные зоны вокруг проекта",
        "Около 5 км до конгресс-центра и выставочного комплекса Tüyap",
        "Близость к транспортным развязкам",
        "Доступ к Marmara Park, Torium, City Center, Perlavista",
        "Связь с аэропортом Стамбула и региональными транспортными осями",
      ],
    },
    plans: {
      overline: "Планы проекта", title: "Планы",
      text: "Просмотрите все планы и документы проекта в организованной галерее по категориям.",
      categories: ["Все", "Общее представление", "Карты локации", "Генплан", "Резиденция + Отель",
        "Техническая информация блока C", "Планы этажей", "Типы квартир", "Коммерческие зоны", "Отель / зона Ramada", "Термальный и оздоровительный комплекс"],
      fullscreen: "Полный экран", download: "Скачать", sourceNote: "Технический исходный материал",
    },
    gallery: {
      overline: "Галерея", title: "Визуальная галерея",
      text: "Откройте для себя архитектурную эстетику и жилые пространства Phantom Residence.",
      filters: ["Все", "Экстерьер", "Башня", "Входы", "Ландшафт", "Ночной вид", "Коммерческие зоны"],
    },
    investment: {
      overline: "Инвестиции", title: "Ценность жизни и инвестиций",
      text: "Благодаря многофункциональной структуре, комфорту резиденции, коммерческим площадям, оздоровительной и термальной концепции Phantom Residence отвечает не только потребностям сегодняшней жизни, но и инвестиционному потенциалу будущего.",
      cards: [
        { title: "Преимущество смешанного проекта", text: "Резиденция, коммерция, отель и оздоровление в одном проекте." },
        { title: "Коммерческая активность", text: "Постоянно живая экосистема с ТЦ и коммерческими единицами." },
        { title: "Центральная локация", text: "Стратегическое расположение в Эсенюрте рядом с транспортом и жизнью." },
        { title: "Большое число единиц", text: "Сильный масштаб жизни и инвестиций — 1.162 независимых единицы." },
        { title: "Резиденция + Отель", text: "Потенциал размещения и арендного дохода с Ramada." },
        { title: "Оздоровительная и термальная концепция", text: "Ценность оздоровительного туризма с первым термальным отелем Стамбула." },
      ],
    },
    contact: {
      overline: "Контакты", title: "Запись и контакты",
      text: "Свяжитесь с нами, чтобы получить подробную информацию о проекте или записаться на встречу.",
      name: "Имя и фамилия", phone: "Телефон", email: "Эл. почта", interest: "Область интереса",
      interestOptions: ["Резиденция", "Коммерческая площадь", "Инвестиции", "Отель / Термальный / Оздоровительный"],
      message: "Сообщение", submit: "Запросить встречу", whatsapp: "Написать в WhatsApp", call: "Позвонить",
      success: "Ваш запрос получен. Мы свяжемся с вами в ближайшее время.",
      error: "Произошла ошибка. Пожалуйста, попробуйте снова.", sending: "Отправка...",
      required: "Пожалуйста, заполните обязательные поля.",
    },
    footer: {
      tagline: "Новый адрес тихой роскоши", rights: "Все права защищены.",
      menu: "Меню", contact: "Контакты",
      disclaimer: "Изображения и информация на этом сайте носят рекламный характер. Технические документы являются справочными материалами.",
    },
  },
};
